import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VPagination,{staticClass:"mt-4",class:_vm.glass ? 'glass-pagination-component' : '',attrs:{"circle":"","color":_vm.color,"total-visible":_vm.totalVisible,"value":_vm.pagination.current_page,"length":_vm.pagination.last_page,"per-page":_vm.pagination.per_page},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }